import { browserDefaultLineHeight } from 'client/constants/editorSettings'
import usePresentPage from 'client/hooks/usePresentPage'
import {
  getGlobalMobileTextLineHeight,
  getGlobalTextLineHeight,
} from 'client/reducers/pageReducer'
import { useWebsiteSettings } from 'client/store'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'
import { typographySelectorMap } from 'src/editor/store/website-settings/website-settings-selector'
import { getCalculatedProperty } from 'src/shared/utils/get-calculated-property'
import { useFontSize } from './use-font-size'

export const useLineHeight = ({
  fontSize,
  mobileFontSize,
  lineHeight,
  mobileLineHeight,
  typographyType = WebsiteSettingsTypographyTypeEnum.Paragraph,
}: {
  fontSize?: number
  mobileFontSize?: number
  lineHeight?: number
  mobileLineHeight?: number
  typographyType?: WebsiteSettingsTypographyTypeEnum
}) => {
  const typographySelector = typographySelectorMap[typographyType]

  const {
    lineHeight: websiteGlobalLineHeight,
    mobileLineHeight: websiteGlobalMobileLineHeight,
  } = useWebsiteSettings(typographySelector) || {}

  const pageGlobalLineHeight = usePresentPage(getGlobalTextLineHeight) as string
  const pageGlobalMobileLineHeight = usePresentPage(
    getGlobalMobileTextLineHeight,
  )
  const globalLineHeight =
    Number.parseInt(pageGlobalLineHeight) || (websiteGlobalLineHeight as number)
  const globalMobileLineHeight =
    Number.parseInt(pageGlobalMobileLineHeight) ||
    (websiteGlobalMobileLineHeight as number)

  const { calculatedFontSize } = useFontSize({
    fontSize,
    mobileFontSize,
    typographyType: typographyType,
  })

  const computedLineHeight = Math.round(
    browserDefaultLineHeight * (calculatedFontSize.desktop as number),
  )

  const computedMobileLineHeight = Math.round(
    browserDefaultLineHeight * (calculatedFontSize.mobile as number),
  )
  return {
    calculatedLineHeight: getCalculatedProperty({
      desktopProperty: lineHeight,
      mobileProperty: mobileLineHeight,
      globalDesktopProperty: globalLineHeight || computedLineHeight,
      globalMobileProperty: globalMobileLineHeight || computedMobileLineHeight,
    }),
    globalLineHeight,
    globalMobileLineHeight,
  }
}
